import api from '@/api'
import {
  SET_OVERVIEW_AD_LIST,
  SET_OVERVIEW_AD_LIST_PAGE_SIZE,
  SET_OVERVIEW_AD_LIST_TOTAL,
  SET_OVERVIEW_AD_PAGE_COUNT,
} from './mutation-types'
const state = {
  pageSize: 20,
  pageCount: 0,
  total: 0,
  overviewAdList: [],
}
const mutations = {
  [SET_OVERVIEW_AD_LIST](state, payload) {
    state.overviewAdList = payload
  },
  [SET_OVERVIEW_AD_PAGE_COUNT](state, payload) {
    state.pageCount = payload
  },
  [SET_OVERVIEW_AD_LIST_PAGE_SIZE](state, payload) {
    state.pageSize = payload
  },
  [SET_OVERVIEW_AD_LIST_TOTAL](state, payload) {
    state.total = payload
  },
}
const actions = {
  async getOverviewAdList({ state, commit }, payload) {
    let params = {
      pageSize: payload.pageSize,
      pageNum: payload.pageNum,
      advertisingTitle: payload.advertisingTitle,
      startTime: payload.startTime,
      endTime: payload.endTime,
      channel: payload.channel,
    }
    try {
      const {
        data: { items, pageCount, total },
      } = await api.deployApi.getOverviewAdvertiseList(params)
      commit(SET_OVERVIEW_AD_LIST, items)
      commit(SET_OVERVIEW_AD_PAGE_COUNT, pageCount)
      commit(SET_OVERVIEW_AD_LIST_TOTAL, total)
    } catch (error) {
      commit(SET_OVERVIEW_AD_LIST, [])
      commit(SET_OVERVIEW_AD_PAGE_COUNT, 0)
    }
  },
  refreshOverviewAdList({ dispatch }) {
    dispatch('getOverviewAdList', { pageNum: 1, pageSize: state.pageSize })
  },
  updatePageSize({ commit }, payload) {
    commit(SET_OVERVIEW_AD_LIST_PAGE_SIZE, payload)
  },
  // 新增
  async addOverviewAdvertise({ dispatch }, payload) {
    const result = await api.deployApi.addOverviewAdvertise(payload)
    dispatch('refreshOverviewAdList')
    return result
  },
  // 编辑
  async editOverviewAdvertise({ dispatch }, payload) {
    const result = await api.deployApi.editOverviewAdvertise(payload)
    dispatch('refreshOverviewAdList')
    return result
  },
  // 删除
  async deleteOverviewAdvertise({ dispatch }, payload) {
    const result = await api.deployApi.deleteOverviewAdvertise(payload)
    dispatch('refreshOverviewAdList')
    return result
  },
  async exportOverviewAdvertise({ dispatch }, payload) {
    const result = await api.deployApi.exportOverviewAdvertise(payload)
    dispatch('refreshOverviewAdList')
    return result
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
